export default __webpack_public_path__ + "static/success-1e39539e791f041af99122d2a535180b.svg";